module.exports = __webpack_public_path__ + "static/media/figure-2a.8d3f1030.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/faq/change-batteries/figure-2a.jpg
// module id = 1206
// module chunks = 0